import { ChevronDownIcon, GraphIcon, LinkExternalIcon } from '@primer/octicons-react';
import { ActionList, ActionMenu, Box, Link as HrefLink, PageLayout } from '@primer/react';
import { useDispatch, useSelector } from "react-redux";

import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ComboboxHe from '../../components/combobox-he';
import { ComboboxHocKyFixed } from "../../components/combobox-hocky-fixed";
import { ComboboxNamHoc } from "../../components/combobox-namhoc";
import { ComboboxTruong } from "../../components/combobox-truong";
import Button from '../../components/ui/button';
import UserPanel from '../../components/user-panel';
import { useAuth } from '../../hooks/useAuth';
import { IMenuModel } from '../../models/response/account/user-info';
import { actions } from "../../state/actions/actionsWrapper";
import { RootState } from "../../state/reducers";
import MenuGroup from '../menu-group';
import styles from "./Header.module.css";

const VietNamIcon = () => {
    return <img alt='vn' style={{
        height: "16px",
        marginTop: "-2px"
    }} src="../../images/vietnam.png" />
}
const EnglandIcon = () => {
    return <img alt='en' style={{
        height: "16px",
        marginTop: "-2px"
    }} src="../../images/united-kingdom.png" />
}
const LogoIcon = ({ user_info }: any) => {
    return <img alt='logo' style={{ height: "40px" }} src={`${user_info?.vender_logo}`} />
}
const Header = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { user_info } = useAuth();
    const { language } = useSelector((x: RootState) => x.common)
    const { dm_truong_selected_id, nam_hoc, hoc_ky, dm_he_selected_id } = useSelector((x: RootState) => x.common)
    const { appConfig } = useSelector((x: RootState) => x.appConfig)

    const menus = useMemo(() => {
        return user_info?.menus ?? []
    }, [user_info])

    const findMenu = (menu: IMenuModel, pathName: string): IMenuModel | undefined => {
        if (menu.path === pathName) return menu;
        if (menu.items && menu.items.length > 0) {
            for (const subMenu of menu.items) {
                const result = findMenu(subMenu, pathName);
                if (result) return result;
            }
        }
        return undefined;
    };
    const selectedMenu = useMemo(() => {
        const pathName = location.pathname.startsWith('/') ? location.pathname.slice(1) : location.pathname;
        if (menus.length > 0) {
            for (const subMenu of menus) {
                const result = findMenu(subMenu, pathName);
                if (result) return result;
            }
        }

        return undefined;
    }, [menus, location.pathname])


    return (

        <Box sx={{
            borderBottomWidth: "0px",
            borderBottomStyle: "solid",
            borderBottomColor: "border.default",
            borderTopWidth: "0px",
            borderTopStyle: "solid",
            borderTopColor: "border.default",
            backgroundColor: "#182D62",
        }}>
            <PageLayout sx={{ padding: 0 }} containerWidth="full">

                <Box style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",

                }}
                    className={styles.header}
                >
                    <Box className={styles.left} sx={{
                        width: 200,
                        pl: 4,
                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Link to={`${(appConfig?.OIDC_AUTHORITY ?? "").replace("auth", "portal")}`}>
                            <LogoIcon user_info={user_info} />
                        </Link>
                    </Box>
                    
                    <div className={styles.center} style={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <MenuGroup />
                    </div>
                    <div className={styles.dashboardOverlay}>
                        <Link to={"../home"}>
                            <Button text='Dashboard' leadingVisual={GraphIcon} />
                        </Link>
                    </div>
                    <div className={styles.right} style={{
                    }}>

                        <div className={styles.item}>
                            <ActionMenu>
                                <ActionMenu.Anchor>
                                    <ActionMenu.Button aria-label="Select school year"
                                        // trailingAction={ChevronDownIcon}
                                        icon={language === "en" ? EnglandIcon : VietNamIcon}
                                        sx={{
                                            height: "32px",
                                            borderRadius: "8px",
                                            backgroundColor: "rgba(255,255,255,0.2)!important"
                                        }}
                                    >
                                        <></>
                                    </ActionMenu.Button>
                                </ActionMenu.Anchor>

                                <ActionMenu.Overlay width="auto">
                                    <ActionList selectionVariant="single">
                                        <ActionList.Item selected={language === "vi"}
                                            onSelect={() => {
                                                dispatch(actions.common.changeLanguge("vi"))
                                            }}>
                                            <ActionList.LeadingVisual>
                                                <VietNamIcon />
                                            </ActionList.LeadingVisual>
                                            Tiếng Việt</ActionList.Item>
                                        <ActionList.Item selected={language === "en"}
                                            onSelect={() => {
                                                dispatch(actions.common.changeLanguge("en"))
                                            }}>
                                            <ActionList.LeadingVisual>
                                                <EnglandIcon />
                                            </ActionList.LeadingVisual>English</ActionList.Item>

                                    </ActionList>
                                </ActionMenu.Overlay>
                            </ActionMenu>
                        </div>
                        <Box className={styles.item} sx={{ pr: "2px" }}>
                            <UserPanel />
                        </Box>
                    </div>
                </Box>
                <Box sx={{
                    display: "flex",
                    flex: 1,
                    alignItems: "center",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    height: 40
                }}>
                    <Box sx={{ pl: 1, display: "flex", flex: 1, mb: "2px" }} className={styles.items}>
                        <div className={styles.item}>
                            <ComboboxTruong
                                trailingAction={ChevronDownIcon}
                                value={dm_truong_selected_id}
                                onValueChanged={(value) => {
                                    dispatch(actions.common.changedValueHeaderComboboxTruong(value))
                                }}
                            />
                        </div>
                        {/* <div className={styles.item}>
                            <ComboboxHe
                                isShowClearButton
                                trailingAction={ChevronDownIcon}
                                value={dm_he_selected_id}
                                onValueChanged={(value) => {
                                    dispatch(actions.common.changedValueHeaderComboboxHe(value))
                                }}
                            />
                        </div> */}
                        <div className={styles.item}>
                            <ComboboxNamHoc
                                value={nam_hoc}
                                trailingAction={ChevronDownIcon}
                                width="170px"
                                onValueChanged={(value) => {
                                    dispatch(actions.common.changedValueHeaderComboboxNamHoc(value))
                                }}
                            />
                        </div>
                        <div className={styles.item}>
                            <ComboboxHocKyFixed
                                width="100px"
                                trailingAction={ChevronDownIcon}
                                value={hoc_ky}
                                onValueChanged={(value) => {
                                    dispatch(actions.common.changedValueHeaderComboboxHocKy(value))
                                }}
                            />
                        </div>
                    </Box>
                    <Box sx={{ pr: 1 }}>
                        <HrefLink href={selectedMenu?.user_guide_link ?? undefined} target='_blank'

                        >
                            <Button text='Hướng dẫn sử dụng'
                                variant='invisible'
                                sx={{
                                    color: "#fff"
                                }}
                                leadingVisual={LinkExternalIcon}
                            />
                        </HrefLink>
                    </Box>
                </Box>

            </PageLayout>
        </Box>

    );
};

export default Header;